import moment from 'moment';

export const escapeInput = (str: any) => {
  return String(str)
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, `"`)
    .replace(/&#39;/g, `'`)
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&Uuml;/g, 'Ü')
    .replace(/&uuml;/g, 'ü')
    .replace(/&auml;/g, 'ä')
    .replace(/&Auml;/g, 'Ä')
    .replace(/&Ouml;/g, 'Ö')
    .replace(/&ouml;/g, 'ö')
    .replace(/&szlig;/g, 'ß');
};

export const generateFileDownload = (filename: string, data: any) => {
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const url = URL.createObjectURL(new Blob([byteArray], { type: 'application/pdf; charset=utf-8' }));
  generateLinkDownLoad(filename, url);
};

export const generateLinkDownLoad = (filename: string, url: any) => {
  const link = document.createElement('a');
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const showNotification = (type: string, message: string, notify: any) => {
  notify!.current?.show({
    closable: false,
    severity: `${type}`,
    summary: type === 'error' ? `Actung` : `Information`,
    detail: `${message}`,
    life: 3000,
  });
};

export const checkDateInRange = (date: string, receipt_template_id: string) => {
  return checkDateInRange56Days(date, receipt_template_id) && checkDateInRange3Years(date);
};

export const checkDateInRange3Years = (date: string) => {
  const currentDate = moment().utc();
  const targetDate = moment(date).utc();

  const diffYears = targetDate.diff(currentDate, 'years');
  return diffYears > -3;
};

export const checkDateInRange56Days = (date: string, receipt_template_id: string) => {
  const formatCurrentDate = moment().utc().format('MM/DD/YYYY');
  const formatDate = moment(date).utc().format('MM/DD/YYYY');
  const currentDate = moment(formatCurrentDate, 'MM/DD/YYYY').utc().startOf('day');
  const targetDate = moment(formatDate, 'MM/DD/YYYY').utc().startOf('day');

  const diffDays = currentDate.diff(targetDate, 'days');
  return receipt_template_id === 'RO3' ? diffDays < 56 : diffDays < 14;
};

export const checkIsRO3 = (receipt_template_id: string) => {
  return receipt_template_id === 'RO3' ? 56 : 14;
};

export const formatStringToNumber = (numberString: any) => {
  if (numberString) {
    if (typeof numberString === 'string') {
      return parseFloat(numberString);
    } else {
      return numberString;
    }
  }
  return 0;
};

export const parseFloatByLanguage = (number: any, lang: any, minimumFractionDigits: any = null, maximumFractionDigits: any = null) => {
  if (minimumFractionDigits && maximumFractionDigits) {
    return parseFloat(number?.toString())?.toLocaleString(lang === 'en' ? 'en-US' : 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return parseFloat(number?.toString())?.toLocaleString(lang === 'en' ? 'en-US' : 'de-DE');
};

const isBrowser = () => typeof localStorage !== 'undefined';
export const getLanguageCode = () => {
  return isBrowser() ? localStorage.getItem('language_code') : 'de';
};

export const renderRegionName = (regionName: any): string => {
  if (!regionName) return '';

  const languageCode = getLanguageCode() || 'de';

  if (typeof regionName === 'object') {
    return regionName[languageCode] || '';
  }

  if (typeof regionName === 'string') {
    try {
      const parsed = JSON.parse(regionName);
      if (parsed && typeof parsed === 'object') {
        return parsed[languageCode] || '';
      }
    } catch {
      return regionName;
    }
  }

  return String(regionName);
};
